import * as React from "react"
import { CheckIcon } from "lucide-react"
import { Checkbox as CheckboxPrimitive } from "radix-ui"

import { cn } from "@/lib/utils"

function Checkbox({
    className,
    ...props
}) {
    return (
        <CheckboxPrimitive.Root
            data-slot="checkbox"
            className={cn(
                // `border-input` resolves against `--input`, a CSS variable
                // `themes/styles/*.js` never defines (only `--color-input-border`
                // is set), so the boundary of an unchecked box was invisible in
                // every theme. `border-border-input` is the token that is
                // actually wired up — the one `.claude/rules/frontend-ux.md`
                // names for a control someone types or clicks into.
                "peer relative flex size-4 shrink-0 items-center justify-center rounded-[4px] border border-border-input transition-colors outline-none group-has-disabled/field:opacity-50 after:absolute after:-inset-x-3 after:-inset-y-2 focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 aria-invalid:aria-checked:border-primary dark:bg-input/30 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40 data-checked:border-primary data-checked:bg-primary data-checked:text-primary-foreground dark:data-checked:bg-primary",
                className
            )}
            {...props}
        >
            <CheckboxPrimitive.Indicator
                data-slot="checkbox-indicator"
                className="grid place-content-center text-current transition-none [&>svg]:size-3.5"
            >
                <CheckIcon />
            </CheckboxPrimitive.Indicator>
        </CheckboxPrimitive.Root>
    )
}

export { Checkbox }
